import { render, staticRenderFns } from "./donor-donations.vue?vue&type=template&id=0407f082&"
import script from "./donor-donations.vue?vue&type=script&lang=js&"
export * from "./donor-donations.vue?vue&type=script&lang=js&"
import style0 from "./donor-donations.vue?vue&type=style&index=0&id=0407f082&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports